var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "footer" },
    [
      _c("router-link", { attrs: { to: "/tos" } }, [
        _vm._v("Terms of Service"),
      ]),
      _vm._v(" "),
      _c("router-link", { attrs: { to: "/privacy" } }, [_vm._v("Privacy")]),
      _vm._v(" "),
      _c("a", { attrs: { href: "mailto:support@lmk.chat" } }, [
        _vm._v("Support"),
      ]),
      _vm._v(" "),
      _c("a", { attrs: { href: "mailto:support@lmk.chat" } }, [
        _vm._v("Careers"),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/components/common/Footer.vue